import { curry } from 'ramda'

// eslint-disable-next-line import/prefer-default-export
export const randomNumberInRange = curry((min, max) => {
  const range = max - min
  return Math.random() * range + min
})

export const randomBool = () => Math.random() >= 0.5



// WEBPACK FOOTER //
// ./src/components/helpers/random.js